import { Link } from 'react-router-dom'
import { Package, AlertCircle, MessageSquare } from 'lucide-react'
import GoogleDriveEmbed from '../components/GoogleDriveEmbed'
import { Card } from '../components/ui'
import abcLogo from '../assets/abc-logo.webp'

const GDRIVE_FOLDER_ID = import.meta.env.VITE_GDRIVE_FOLDER_ID
const GDRIVE_FOLDER_NAME = import.meta.env.VITE_GDRIVE_FOLDER_NAME

function Dashboard() {
  const dataEntryTools = [
    {
      title: 'Products Manager',
      path: '/products',
      icon: Package,
      color: 'bg-primary-500 hover:bg-primary-600'
    },
    {
      title: 'Issues Resolution',
      path: '/issues',
      icon: AlertCircle,
      color: 'bg-warning-500 hover:bg-warning-600'
    },
    {
      title: 'Clarifications',
      path: '/clarifications',
      icon: MessageSquare,
      color: 'bg-purple-500 hover:bg-purple-600'
    }
  ]

  return (
    <div className="space-y-6">
      {/* Centered Logo */}
      <div className="flex justify-center animate-fade-in">
        <img
          src={abcLogo}
          alt="ABC Consulting"
          className="h-16 sm:h-20 lg:h-24"
        />
      </div>

      {/* Welcome Text */}
      <div className="animate-fade-in text-center">
        <p className="text-neutral-600">
          Welcome to Operations - Admin SW Support Tools
        </p>
      </div>

      {/* Data Entry Tools */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-2xl mx-auto">
        {dataEntryTools.map((tool, index) => (
          <Link
            key={tool.path}
            to={tool.path}
            className="block animate-fade-in focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 rounded-lg"
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <Card
              hoverable
              noPadding
              className="overflow-hidden"
            >
              <div className={`${tool.color} p-4 transition-colors duration-150`}>
                <tool.icon className="w-10 h-10 text-white mx-auto" />
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-neutral-900 text-center leading-tight">
                  {tool.title}
                </h3>
              </div>
            </Card>
          </Link>
        ))}
      </div>

      {/* Shared Files - Google Drive Embed */}
      {GDRIVE_FOLDER_ID && (
        <div className="animate-fade-in" style={{ animationDelay: '0.4s' }}>
          <GoogleDriveEmbed folderId={GDRIVE_FOLDER_ID} folderName={GDRIVE_FOLDER_NAME} height="350px" />
        </div>
      )}

      {/* Footer */}
      <div className="text-center text-sm text-neutral-500 pt-4">
        <p>Version 1.0.0 | 2026 Operations - Admin SW Support Tools</p>
      </div>
    </div>
  )
}

export default Dashboard
